import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import { AesDecryptlive } from "../middleware/AesDecryptlive";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { type } from "@testing-library/user-event/dist/type";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Inlogo, Bbpsasured, xopaylogo2, susimg } from '../component/image';


let Category = () => {
  const location = useLocation();
  const state = location.state;
  let navigate = useNavigate();
  const contentRef = useRef();

  const [data, setData] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const [ser, setUsr] = useState(false);
  const [ddta, setDdta] = useState();
  const [one, setOne] = useState();
  let [count, setCount] = useState();
  const [onedata, setOnedata] = useState();

  let [value, inputvalue] = useState();

  let [sel, setSel] = useState();

  const [text, setText] = useState("");

  const [val, setVal] = useState(0);

  const [vals, setVals] = useState("Success");

  const [htmlString, sethtmlString] = useState("");

  //   const htmlString = `
  //   <div class="invoice2" style="font-family: Arial, sans-serif;">
  //     <div style="display: flex; justify-content: space-between; margin-top: -20px;">
  //       <p style="font-size: 15px; font-weight: 700">Total Amount</p>
  //       <p style="font-size: 15px; font-weight: 700">INR 14000</p>
  //     </div>
  //     <img style="width: 80px; position: absolute; margin-top: -80px; margin-left: 40%" src="data:image/png;base64,susimg" />
  //     <img style="width: 80px; margin-left: auto; display: block" src="data:image/png;base64,inlogo" />
  //     <p style="text-align: center; font-size: 11px; margin-bottom: 10px;">Support Email : support@xopay.in</p>
  //     <p style="text-align: center; font-size: 11px;">This receipt generated by computer</p>
  //   </div>
  // `;

  const showAlert = () => {
    window.alert("Click OK to run the function.");
    console.log(one.user._id      , 'sssssssssssssssssssssssssssssssssssssssssssssssssss')
    converttt()
    // logout();
  };


  function markUserAsFraud(data, targetUserId, fraudStatus) {
    return data.map(item => {
      if (item.user && item.user._id === targetUserId) {
        return {
          ...item,
          user: {
            ...item.user,
            fraud: fraudStatus
          }
        };
      }
      return item;
    });
  }



  let converttt = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }

    let pp = { token, id: one.user._id };
    let datas = await AesEncrypt(pp);

    console.log(one.user._id  , 'one.user._id one.user._id ')

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/alldata_bbps",
      data: pp ,
    })
      .then((dat) => { 
        let Jsson = dat.data;
        window.location.reload();
        // markUserAsFraud(data, one.user._id, Jsson.fraud)
        // console.log( JSON.stringify( data), "Jsson");
        // one.user.fraud = Jsson.fraud
      })
      .catch((ee) => {
        console.log(ee, "Jsson");
      });
  };


  const togglePanel = async (tt) => {
    setOne(tt);

    console.log(tt);

    setIsOpen(true);
  };

  useEffect(() => {
    console.log(state, "statestate");
    Start();
  }, []);

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  const handlePageClick = async (event) => {
    console.log(state, "state");

    setVal(event.selected);
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/onedatass",
      data: {
        name: state,
        limit: 10,
        skip: event.selected,
        type: onedata
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);
        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  let Start = async () => {
    console.log(state, "state");

    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/alldata",
      data: {
        name: state,
        limit: 10,
        skip: 0,
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);

        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
          setText(Jsson?.text);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };



  let retry = async (tt) => {
    let foo = prompt("Type here");

    if (foo === text) {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      setUsr(true);
      let pp = { token, value: tt };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/retry",
        data: {
          value: tt,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          setUsr(false);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            window.location.reload();
          } else {
            alert(Jsson.message);
          }
          // window.location.reload();
        })
        .catch((ee) => {
          setUsr(false);
          console.log(ee, "rrrrrrrrrrrrrrrrr");
        });
    } else {
      setUsr(false);
      alert("Plz Contact The admin");
    }
  };


  let retrys = async (tt) => {

    console.log(tt, "ttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttt");
 
 
    let foo = prompt("Type here");

    if (foo === text) {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      setUsr(true);
      let pp = { token, value: tt };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/billpay/paysus",
        data: {
          txnid : tt?.pg_transactionId,
          status : "success"
        },
      }) 
        .then((dat) => {
           console.log(dat, "Jsson dfssgdffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff g");
          let parsedata = AesDecryptlive(dat.data);
          let Jsson = JSON.parse(parsedata);
          setUsr(false);
          console.log(parsedata, "Jsson dfssgdffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
          if (Jsson.status === true) {
            
          } else {
            alert(Jsson.message);
          }
          window.location.reload();
          // window.location.reload();
        })
        .catch((ee) => {
          setUsr(false);
          window.location.reload();
          console.log(ee, "rrrrrrrrrrrrrrrrr");
        });
    } else {
      setUsr(false);
      alert("Plz Contact The admin");
    }
  };

  let submit = async () => {
    console.log(one, vals);

    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/creditcardupdate",
      data: {
        _id: one._id,
        value: vals,
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);
        setUsr(false);
        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          window.location.reload();
        } else {
          alert(Jsson.message);
        }
        // window.location.reload();
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  // useEffect(() => {
  //   Filter();
  // }, [sel]);

  let Filter = async (seee) => {
    setOnedata(seee)
    if (seee === "All") {
      Start();
    } else {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      let pp = { token, name: state, type: seee };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/onedatass",
        data: {
          name: state,
          limit: 10,
          skip: 0,
          type: seee,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson?.count);
            setText(Jsson?.text);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {
          console.log(ee, "rrrrrrrrrrrrrrrrr");
        });
    }
  };

  let searchss = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/searchh",
      data: {
        name: state,
        limit: 10,
        skip: 0,
        type: value,
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);

        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
          setText(Jsson?.text);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  let submitpdf = async () => {


    console.log(one, 'oneoneoneoneoneoneoneoneoneoneoneoneoneoneone');


    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    // let pp = { token, name: state };
    // let data = await AesEncrypt(pp);

    let value = {
      biller: one.creditCardHistory,
      alldata: one,
      all: one,
    };

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/billpay/pdfgens",
      data: {
        data: value,
      },
    })
      .then(async (dat) => {
        console.log(dat.data, "Jsson");
        try {

          let one = dat.data.data.replace('inlogo', xopaylogo2);
          let two = one.replace('Inlogo', Inlogo);

          let three = two.replace('susimg', susimg);
          let four = three.replace('Bbpsasured', Bbpsasured);


          sethtmlString(four);

          setTimeout(() => {
            gigk()
          }, 2000);

          let gigk = (async () => {
            const element = contentRef.current;

            const canvas = await html2canvas(element, {
              scale: 6, // 🟢 Higher scale = sharper image
              useCORS: true,
            });
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('receipt.pdf');
          })


        } catch (e) {
          console.log(e)
        }


      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  function getServiceNumberBrowser(xmlString) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    
    const inputElements = xmlDoc.getElementsByTagName("input");
    
    for (let input of inputElements) {
        const paramName = input.getElementsByTagName("paramName")[0].textContent;
        if (paramName === "Service Number") {
            const serviceNumber = input.getElementsByTagName("paramValue")[0].textContent;
            return serviceNumber;
        }
    }
    return null;
}

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }}>
          <div style={{ padding: 20 }}>
            <div className="row">
              <div className="col-3">
                <p>
                  {state} {"(" + data?.length + ")"}
                </p>
              </div>
              <div className="col-3">
                <select
                  onChange={(e) => {
                    setSel(e.target.value);
                    Filter(e.target.value);
                  }}
                  name="cars"
                  id="cars"
                >
                  <option value="All" selected={sel === "All" ? true : false}>
                    All
                  </option>
                  <option
                    value="Failed"
                    selected={sel === "Failed" ? true : false}
                  >
                    Failed
                  </option>
                  <option
                    value="Success"
                    selected={sel === "Success" ? true : false}
                  >
                    Success
                  </option>
                  <option
                    value="Progress"
                    selected={sel === "Progress" ? true : false}
                  >
                    Processing
                  </option>

                  <option
                    value="Refund"
                    selected={sel === "Refund" ? true : false}
                  >
                    Refund
                  </option>
                </select>
              </div>
              <div className="col-3">
                <input
                  onChange={(e) => {
                    inputvalue(e.target.value);
                  }}
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="Enter Order Id"
                />
              </div>
              <div className="col-3">
                <button
                  onClick={() => {
                    searchss();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>

            {state === "Credit Card" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Card Detail</th>
                      <th scope="col">Payment Detail</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};
                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }

                      let jsonfbf = null;
                      if (tt?.creditCardHistory?.jsonResponse) {
                        try {
                          jsonfbf = JSON.parse(tt.creditCardHistory.jsonResponse);
                        } catch (error) {
                          console.error('Invalid JSON in jsonResponse:', error);
                          jsonfbf = null; // or provide a default value
                        }
                      }

                        let datassss = [];

                      if (tt?.creditCardHistory?.props) {
                        try {
                          const parsed = JSON.parse(tt.creditCardHistory.props);
                          datassss = Array.isArray(parsed) ? parsed : [parsed]; // force array
                        } catch (err) {
                          console.error("Failed to parse JSON:", err);
                          datassss = [];
                        }
                      }

                      return (
                        <tr

                          
                          onClick={() => {
 

                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">{index + val * 10 + 1}</th>
                          <td style={{ backgroundColor : tt?.user?.fraud === true ? "#ff8d30" : "white" }} >
                            <div>
                              <p>Name : {tt?.user?.name}</p>
                              <p>Phone No : {tt?.user?.phoneno}</p>
                              <p>Email : {tt?.user?.email}</p>

                              <p style={{ fontWeight: "700" }}>
                                Bank Name : {tt?.billerinfo?.billerName}
                              </p>
                              <p style={{ fontWeight: "700" }}>
                                Biller Id : {tt?.billerinfo?.billerId}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              {datassss?.map((item, index) => (
                                <div key={index} className="    ">
                                  {Object.entries(item).map(([key, value]) => (
                                    <p key={key} className="mb-2  " style={{ fontWeight: "700" }}>
                                      <span className="font-medium">{key}:</span> {value}
                                    </p>
                                  ))}
                                </div>
                              ))}
                              <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                              <p>Xopay Id : {tt?.xopayid}</p>
                              <p>
                                Type :{" "}
                                {tt?.type ||
                                  "NA"}
                              </p>
                              <p>
                                Payment Method :{" "}
                                {paymensss?.mode ||
                                  paymensss?.data?.paymentInstrument?.type ||
                                  paymensss?.data?.order?.response?.data?.paymentInstrument?.type || "NA"}
                              </p>

                              <p>
                                Payment Method type:{" "}
                                {paymensss?.cardCategory ||
                                  paymensss?.data?.paymentInstrument?.cardType ||
                                  paymensss?.data?.order?.response?.data?.paymentInstrument?.cardType || "NA"}
                              </p>

                              <p style={{ fontWeight: '600', color: 'red' }} >
                                Due Date :{jsonfbf?.billerResponse?.dueDate?._text || " NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount}</p>
                              <p>Con Fess : ₹ {tt?.confess}</p>
                              <p>Total : ₹ {tt?.total}</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p
                                style={{
                                  color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                        ? "green"
                                        : "orange",
                                }}
                              >
                                {tt?.payment_status_msg}
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Mobile Postpaid" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Card Detail</th>
                      <th scope="col">Payment Detail</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }
                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>
                            <div>
                              <p>Names : {tt?.user?.name}</p>
                              <p>Phone No : {tt?.user?.phoneno}</p>
                              <p>Email : {tt?.user?.email}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>
                                billNumber : {tt?.creditCardHistory?.billNumber}
                              </p>
                              <p>
                                billDate : {tt?.creditCardHistory?.billDate}
                              </p>

                              <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                              <p>Xopay Id : {tt?.xopayid}</p>
                              <p>
                                Type :{" "}
                                {tt?.type ||
                                  "NA"}
                              </p>
                              <p>
                                Payment Method :{" "}
                                {paymensss?.data?.payment?.payment_group ||
                                  paymensss?.data?.paymentInstrument?.type || "NA"}
                              </p>
                              <p>
                                Payment Method type:{" "}
                                {
                                  paymensss?.data?.paymentInstrument?.cardType || "NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount}</p>
                              <p>Con Fess : ₹ {tt?.confess}</p>
                              <p>Total : ₹ {tt?.total}</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p
                                style={{
                                  color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                        ? "green"
                                        : "orange",
                                }}
                              >
                                {tt?.payment_status_msg}
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Mobile Prepaid" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Card Detail</th>
                      <th scope="col">Payment Detail</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }
                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {index + val * 10 + 1}
                          </th>
                          <td>
                            <div>
                              <p>Names : {tt?.user?.name}</p>
                              <p>Phone No : {tt?.user?.phoneno}</p>
                              <p>Email : {tt?.user?.email}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>
                                Phone No : {tt?.phone}
                              </p>
                              <p>
                                type : {tt?.type}
                              </p>

                              <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                              <p>Xopay Id : {tt?.xopayid}</p>
                              <p>
                                Type :{" "}
                                {tt?.type ||
                                  "NA"}
                              </p>
                              <p>
                                Payment Method :{" "}
                                {paymensss?.data?.payment?.payment_group ||
                                  paymensss?.data?.paymentInstrument?.type || "NA"}
                              </p>
                              <p>
                                Payment Method type:{" "}
                                {
                                  paymensss?.data?.paymentInstrument?.cardType || "NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount}</p>
                              <p>Con Fess : ₹ {tt?.confess}</p>
                              <p>Total : ₹ {tt?.total}</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p
                                style={{
                                  color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                        ? "green"
                                        : "orange",
                                }}
                              >
                                {tt?.payment_status_msg}
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Fastag" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User</th>
                      <th scope="col">Ids</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      console.log(tt , 'DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDd');
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }


                      let datassss = [];

                      if (tt?.creditCardHistory?.props) {
                        try {
                          const parsed = JSON.parse(tt.creditCardHistory.props);
                          datassss = Array.isArray(parsed) ? parsed : [parsed]; // force array
                        } catch (err) {
                          console.error("Failed to parse JSON:", err);
                          datassss = [];
                        }
                      }

                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {index + val * 10 + 1}
                          </th>
                          <td>
                            <p>Name : {tt?.user?.name}</p>
                            <p>Phone No : {tt?.user?.phoneno}</p>
                            <p>Email : {tt?.user?.email}</p>

                            <p style={{ fontWeight: "700" }}>
                              Bank Name : {tt?.billerinfo?.billerName}
                            </p>
                            <p style={{ fontWeight: "700" }}>
                              Biller Id : {tt?.billerinfo?.billerId}
                            </p>
                          </td>
                          <td>
                            <div>
                              {/* <p>
                                Customer Name :{" "}
                                {tt?.creditCardHistory?.customerName}
                              </p>
                              <p style={{ color: "blue", fontWeight: "700" }}>
                                Vehicle Number :{" "}
                                {tt?.creditCardHistory?.vehicleNumber}
                              </p> */}

                              {datassss?.map((item, index) => (
                                <div key={index} className="    ">
                                  {Object.entries(item).map(([key, value]) => (
                                    <p key={key} className="mb-2  " style={{ fontWeight: "700" }}>
                                      <span className="font-medium">{key}:</span> {value}
                                    </p>
                                  ))}
                                </div>
                              ))}
                              
                              <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                              <p>Xopay Id : {tt?.xopayid}</p>
                              <p>
                                Type :{" "}
                                {tt?.type ||
                                  "NA"}
                              </p>
                              <p>
                                Payment Method :{" "}
                                {paymensss?.data?.payment?.payment_group ||
                                  paymensss?.data?.paymentInstrument?.type || "NA"}
                              </p>
                              <p>
                                Payment Method type:{" "}
                                {
                                  paymensss?.data?.paymentInstrument?.cardType || "NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount}</p>
                              <p>Con Fess : ₹ {tt?.confess}</p>
                              <p>Total : ₹ {tt?.total}</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td
                            style={{
                              color:
                                tt?.payment_status_msg === "Processing" ||
                                  tt?.payment_status_msg === "Progress"
                                  ? "orange"
                                  : tt?.payment_status_msg === "Failed"
                                    ? "red"
                                    : "green",
                              fontWeight: "700",
                            }}
                          >
                            {tt?.payment_status_msg}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Electricity" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Ids</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }


                      let nre_pal = getServiceNumberBrowser(tt?.creditCardHistory?.reqdata);


                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">{index + val * 10 + 1}</th>
                          <td>
                            <div>
                              <p>Name : {tt?.user?.name}</p>
                              <p>Phone No : {tt?.user?.phoneno}</p>
                              <p>Email : {tt?.user?.email}</p>

                              <p style={{ fontWeight: "700" }}>
                                Bank Name : {tt?.billerinfo?.billerName}
                              </p>
                              <p style={{ fontWeight: "700" }}>
                                Biller Id : {tt?.billerinfo?.billerId}
                              </p>
                            </div>
                          </td>
                          <td>

                            <p>
                              Bill Number :{" "}
                              {tt?.creditCardHistory?.billNumber}
                            </p>
                              <p style={{ color: "red", fontWeight: "700" }}>
                              customer Number :{" "}
                              {nre_pal}
                            </p>
                            <p style={{ color: "blue", fontWeight: "700" }}>
                              customerName :{" "}
                              {tt?.creditCardHistory?.customerName}
                            </p>

                             <p style={{ color: "blue", fontWeight: "700" }}>
                              dueDate :{" "}
                              {tt?.creditCardHistory?.dueDate}
                            </p>

                            <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                            <p>Xopay Id : {tt?.xopayid}</p>
                            <p>
                              Type :{" "}
                              {tt?.type ||
                                "NA"}
                            </p>
                            <p>
                              Payment Method :{" "}
                              {paymensss?.data?.payment?.payment_group ||
                                paymensss?.data?.paymentInstrument?.type || "NA"}
                            </p>
                            <p>
                              Payment Method type:{" "}
                              {
                                paymensss?.data?.paymentInstrument?.cardType || "NA"}
                            </p>
                          </td>
                          <td>
                            <p>Amount : ₹ {tt?.amount}</p>
                            <p>Con Fess : ₹ {tt?.confess}</p>
                            <p>Total : ₹ {tt?.total}</p>
                            <p>
                              Time :{" "}
                              {convertAndFormatTimestamp(tt?.createdAt) ||
                                "NA"}{" "}
                            </p>

                          </td>
                          <td
                            style={{
                              color:
                                tt?.payment_status_msg === "Failed"
                                  ? "red"
                                  : tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : "orange",
                              fontWeight: "700",
                            }}
                          >
                            {tt?.payment_status_msg}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "LPG Gas" ?
              (
                <div style={{ marginTop: 20 }}>
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">User </th>
                        <th scope="col">Total</th>
                        <th scope="col">Ids</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((tt, index) => {
                        let paymensss = {};

                        if (tt?.pg_res != undefined) {
                          paymensss = JSON.parse(tt?.pg_res);
                        }

                        return (
                          <tr
                            onClick={() => {
                              togglePanel(tt);
                            }}
                          >
                            <th scope="row">
                              {index + val * 10 + 1}
                            </th>
                            <td>
                              <div>
                                <p>Name : {tt?.user?.name}</p>
                                <p>Phone No : {tt?.user?.phoneno}</p>
                                <p>Email : {tt?.user?.email}</p>

                                <p style={{ fontWeight: "700" }}>
                                  Bank Name : {tt?.billerinfo?.billerName}
                                </p>
                                <p style={{ fontWeight: "700" }}>
                                  Biller Id : {tt?.billerinfo?.billerId}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div>
                                <p>
                                  Customer Name :{" "}
                                  {tt?.creditCardHistory?.customerName}
                                </p>
                                <p>
                                  Mobile Number :{" "}
                                  {tt?.creditCardHistory?.mobileNumber}
                                </p>

                                <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                                <p>Xopay Id : {tt?.xopayid}</p>
                                <p>
                                  Type :{" "}
                                  {tt?.type ||
                                    "NA"}
                                </p>
                                <p>
                                  Payment Method :{" "}
                                  {paymensss?.data?.payment?.payment_group ||
                                    paymensss?.data?.paymentInstrument?.type || "NA"}
                                </p>
                                <p>
                                  Payment Method type:{" "}
                                  {
                                    paymensss?.data?.paymentInstrument?.cardType || "NA"}
                                </p>

                              </div>
                            </td>
                            <td>
                              <div>
                                <p>Amount : ₹ {tt?.amount}</p>
                                <p>Con Fess : ₹ {tt?.confess}</p>
                                <p>Total : ₹ {tt?.total}</p>
                                <p>
                                  Time :{" "}
                                  {convertAndFormatTimestamp(tt?.createdAt) ||
                                    "NA"}{" "}
                                </p>
                              </div>
                            </td>
                            <td style={{
                              color:
                                tt?.payment_status_msg === "Failed"
                                  ? "red"
                                  : tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : "orange",
                              fontWeight: "700",
                            }} >{tt?.payment_status_msg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )


              : (
                <div style={{ marginTop: 20 }}>
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">User </th>
                        <th scope="col">Total</th>
                        <th scope="col">Ids</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((tt, index) => {
                        let paymensss = {};

                        if (tt?.pg_res != undefined) {
                          paymensss = JSON.parse(tt?.pg_res);
                        }

                        return (
                          <tr
                            onClick={() => {
                              togglePanel(tt);
                            }}
                          >
                            <th scope="row">
                              {index + val * 10 + 1}
                            </th>
                            <td>
                              <div>
                                <p>Name : {tt?.user?.name}</p>
                                <p>Phone No : {tt?.user?.phoneno}</p>
                                <p>Email : {tt?.user?.email}</p>

                                <p style={{ fontWeight: "700" }}>
                                  Bank Name : {tt?.billerinfo?.billerName}
                                </p>
                                <p style={{ fontWeight: "700" }}>
                                  Biller Id : {tt?.billerinfo?.billerId}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div>
                                <p>
                                  Customer Name :{" "}
                                  {tt?.creditCardHistory?.customerName}
                                </p>
                                <p>Pg transaction Id : {tt?.pg_transactionId}</p>
                                <p>Xopay Id : {tt?.xopayid}</p>
                                <p>
                                  Type :{" "}
                                  {tt?.type ||
                                    "NA"}
                                </p>
                                <p>
                                  Payment Method :{" "}
                                  {paymensss?.data?.payment?.payment_group ||
                                    paymensss?.data?.paymentInstrument?.type || "NA"}
                                </p>
                                <p>
                                  Payment Method type:{" "}
                                  {
                                    paymensss?.data?.paymentInstrument?.cardType || "NA"}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div>
                                <p>Amount : ₹ {tt?.amount}</p>
                                <p>Con Fess : ₹ {tt?.confess}</p>
                                <p>Total : ₹ {tt?.total}</p>
                                <p>
                                  Time :{" "}
                                  {convertAndFormatTimestamp(tt?.createdAt) ||
                                    "NA"}{" "}
                                </p>
                              </div>
                            </td>
                            <td style={{
                              color:
                                tt?.payment_status_msg === "Failed"
                                  ? "red"
                                  : tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : "orange",
                              fontWeight: "700",
                            }} >{tt?.payment_status_msg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

            <div style={{ marginTop: 20 }}>
              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={count / 10}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
              />


            </div>
          </div>
        </div>
      </div>

      <div className={`side-panel ${isOpen ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          <p style={{ fontWeight: "700" }}>{one?.category} Detail</p>
          {one?.category === "Fastag" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Vehicle Number</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName}</p>
                <p style={{ fontSize: 11 }}>{ddta?.vehicleNumber}</p>
                <p style={{ fontSize: 11 }}>{one?.phone}</p>
                <p style={{ fontSize: 11 }}>₹ {one?.total}</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date)}
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId}</p>
              </div>
            </div>
          ) : one?.category === "LPG Gas" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName}</p>
                <p style={{ fontSize: 11 }}>
                  {one?.phone === undefined ? "NA" : one?.phone}
                </p>
                <p style={{ fontSize: 11 }}>₹ {one?.total}</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date)}
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId}</p>
              </div>
            </div>
          ) : one?.category === "Electricity" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }} onClick={()=>{
                  console.log(ddta , 'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW')
                }}>Consumer Number</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName}</p>
                <p style={{ fontSize: 11 }}>
                  {one?.phone === undefined ? "NA" : one?.phone}
                </p>
                <p style={{ fontSize: 11 }}>₹ {one?.total}</p>
                <p style={{ fontSize: 11 }}>{ddta?.consumerNumber}</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date)}
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId}</p>
              </div>
            </div>
          ) : (
            ""
          )}

          <p style={{ fontWeight: "700" }}>User Detail</p>
          <div className="row">
            <div className="col-6">
              <div>
                <p>Name : {one?.user?.name}</p>
                <p>Phone No : {one?.user?.phoneno}</p>
                <p>Email : {one?.user?.email}</p>
              </div>
            </div>

            <div className="col-6">
              <div>
                <p
                  style={{
                    color:
                      one?.payment_status_msg === "Failed"
                        ? "red"
                        : one?.payment_status_msg === "Success"
                          ? "green"
                          : "orange",
                  }}
                >
                  {one?.payment_status_msg}
                </p>

                {one?.payment_status_msg === "Success" ||
                  ser === true ||
                  one?.payment_status_msg === "Failed" ||
                  one?.payment_status_msg === "Refund" ? (
                  ""
                ) : (
                  <button
                    onClick={() => {
                      retry(one);
                    }}
                  >
                    Retry
                  </button>
                )}

                 {one?.payment_status_msg === "Progress" ? (
                  <button
                    onClick={() => {
                      retrys(one);
                    }}
                    style={{ marginLeft : 10 }}
                  >
                    New bbps Retry
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>

          <div style={{ justifyContent: "space-evenly", display: "flex" }}>
            <select
              onChange={(e) => {
                console.log(e.target.value);
                setVals(e.target.value);
              }}
            >
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
              <option value="Progress">Progress</option>
              <option value="Refund">Refund</option>
            </select>

            <button
              onClick={() => {
                submit();
              }}
            >
              Submit
            </button>
          </div>
          {
            one?.payment_status_msg === "Success" ?

              <div style={{ justifyContent: "space-evenly", display: "flex" }} className="mt-4">
                <div
                  ref={contentRef}
                  style={{ width: '215mm', backgroundColor: 'white' }}
                  dangerouslySetInnerHTML={{ __html: htmlString }}
                />

                <button
                  onClick={() => {
                    submitpdf();
                  }}
                >
                  Download PDF
                </button>
              </div>

              : ""
          }

          <div style={{ justifyContent: "space-evenly", display: "flex" }} className="mt-4">
            <div 
              style={{ width: '215mm', backgroundColor: 'white' }} 
            />

            <button
              onClick={() => {
                showAlert() 
              }}
            >
              Fraud
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Category;
